import { CSSProperties, useContext } from 'react';
import { Icon } from '@shared/components/Icon';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { isStaticTextComponent } from '@shared/scenes/workflows/utils';
import { ColorThemeContext, grid } from '@shared/styles';
import { API } from '@shared/types/api';

interface Props {
  component: API.StaticTextComponentFragment;
  style?: CSSProperties;
}

export function StaticTextEditField({ component, style }: Props) {
  const colors = useContext(ColorThemeContext);

  if (!isStaticTextComponent(component)) {
    return null;
  }

  return (
    <View row centerVertically style={{ ...style, paddingTop: grid(2), paddingBottom: grid(3) }}>
      <View marginRight={1}>
        <Icon name="info-i" color={colors.foregroundInactive} gridSize={3} />
      </View>
      <View flex>
        <Text size="body1" color={colors.foregroundActive}>
          {component.text}
        </Text>
      </View>
    </View>
  );
}
